import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Canonical host: apex → www (backup for the Cloudflare-level redirect)
if (window.location.hostname === "nexoracentre.ca") {
  window.location.replace(
    `https://www.nexoracentre.ca${window.location.pathname}${window.location.search}${window.location.hash}`
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
